import {Component, Input, OnInit} from '@angular/core';
import {Messagecentral} from '../../../shared/api/messagecentrals/api.models';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Api} from '../../../shared/api.service';
import {Observable} from 'rxjs/Observable';
import {GroupedLanguages} from '../../../shared/languages.resolver';

@Component({
    selector: 'messagecentral-modal',
    template: require('./messagecentral.modal.html'),
    styles: [require('./messagecentral.modal.scss')]
})

export class MessagecentralModal implements OnInit {
    @Input() messagecentral: Messagecentral;
    @Input() languages: GroupedLanguages[] = [];

    protected messagecentralForm: FormGroup;
    protected apiError: string;

    constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private api: Api) {}

    ngOnInit() {
        this.messagecentralForm = this.fb.group({
            id : [this.messagecentral.id],
            name: [
                this.messagecentral.name || 'Berichtencentrale.nl',
                [
                    Validators.required,
                    Validators.maxLength(50)
                ]
            ],
            apiUrl: [
                this.messagecentral.apiUrl || 'https://api.berichtencentrale.nl',
                [
                    Validators.required,
                    Validators.maxLength(120),
                    Validators.pattern(/^https?:\/\//)
                ]
            ],
            apiToken: [
                this.messagecentral.apiToken,
                [
                    Validators.required,
                    Validators.maxLength(120)
                ]
            ]
        });

        this.messagecentralForm.valueChanges.subscribe((messagecentral: Messagecentral) => {
            Object.assign(this.messagecentral, messagecentral);
        })
    }

    save() {
        this.apiError = null;

        let observable: Observable<Messagecentral>;

        if (this.messagecentral.id) {
            observable = this.api.messagecentrals().update(this.messagecentral);
        } else {
            observable = this.api.messagecentrals().create(this.messagecentral);
        }

        observable.subscribe(
            (entity: Messagecentral) => {
                this.activeModal.close(entity);
            },
            (error: any) => {
                if (error.errors) {
                    this.apiError = error.errors[0].detail;
                } else {
                    this.apiError = error.error.message;
                }
            }
        )
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/messagecentrals/components/messagecentral.modal.ts